// 客户api
import api from '@/service/httpServer'

interface Response {
  openId: string;
  passport: string;
  userId: string;
  corpId: string;
}

// 获取项目
export async function getUserInfo(code: string): Promise<[Response, Error | null]> {
  const ret = await api.get(`/qc-webapp/m/repay/getUserInfo?code=${code}`,);
  if (ret.msg != 'success') {
    return [ret.data, new Error(`The interface request failed msg = ${ret.msg}`)];
  };

  if (ret.code != 0) {
    return [ret.data, new Error(`The interface request failed  code = ${ret.code}`)];
  };
  return [ret.data, null];
}